import React, { useState } from 'react';
import { Button, Card, Table, Spinner, Alert, Modal } from 'react-bootstrap';
import { MdGroupAdd } from 'react-icons/md';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { useGroupes } from '../../../hooks/useGetGroupes';
import { useDeleteGroupe } from '../../../hooks/useDeleteGroupe';
import NewGroup from '../../Modals/Create/NewGroup';
import UpdateGroup from '../../Modals/Update/UpdateGroup';

const GroupesTab = () => {
    const [showNewGroup, setShowNewGroup] = useState(false);
    const [showUpdateGroup, setShowUpdateGroup] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [groupeToDelete, setGroupeToDelete] = useState(null);

    // Fetch groupes from API
    const { data: groupesData, isLoading, isError } = useGroupes();
    const { mutate: deleteGroupe, isLoading: isDeleting } = useDeleteGroupe();
    
    const groupes = groupesData?.data?.filter(groupe => groupe.is_active) || [];
    console.log("Groupes récupérés :", groupes);

    const handleEdit = (groupe) => {
        setSelectedGroup(groupe);
        setShowUpdateGroup(true);
    };

    const handleDeleteClick = (groupe) => {
        setGroupeToDelete(groupe);
        setShowDeleteModal(true);
    };

    const confirmDelete = () => {
        if (groupeToDelete) {
            deleteGroupe(groupeToDelete.id, {
                onSuccess: () => {
                    setShowDeleteModal(false);
                    setGroupeToDelete(null);
                }
            });
        }
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" role="status" style={{ color: "#4e73df" }}>
                    <span className="visually-hidden">Chargement...</span>
                </Spinner>
            </div>
        );
    }

    if (isError) {
        return (
            <Alert variant="danger">
                Erreur lors du chargement des groupes
            </Alert>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0">Gestion des groupes</h5>
                <Button variant="primary" className="btn-icon-split" onClick={() => setShowNewGroup(true)}>
                    <span className="icon text-white">
                        <MdGroupAdd size={20} />
                    </span>
                    <span className="text">Ajouter un groupe</span>
                </Button>
            </div>

            <Card className="border-left-group shadow mb-4">
                <Card.Header className="py-3">
                    <h6 className="m-0 fw-bold text-group">Liste des groupes</h6>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nom</th>
                                    <th>Couleur</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupes.length > 0 ? (
                                    groupes.map((groupe) => (
                                        <tr key={groupe.id}>
                                            <td>{groupe.id}</td>
                                            <td>{groupe.name}</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div 
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '50%',
                                                            backgroundColor: groupe.color?.hex || '#cccccc',
                                                            border: '1px solid #dee2e6'
                                                        }}
                                                        title={groupe.color?.name}
                                                    ></div>
                                                    <small className="text-muted">{groupe.color?.name}</small>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <Button 
                                                    variant="link" 
                                                    size="sm" 
                                                    className="me-2 p-1" 
                                                    title="Modifier"
                                                    onClick={() => handleEdit(groupe)}
                                                >
                                                    <FaEdit className="text-warning" />
                                                </Button>
                                                <Button 
                                                    variant="link" 
                                                    size="sm" 
                                                    className="p-1" 
                                                    title="Supprimer"
                                                    onClick={() => handleDeleteClick(groupe)}
                                                >
                                                    <FaTrashAlt className="text-danger" />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            Aucun groupe trouvé
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            <NewGroup showNewGroup={showNewGroup} setShowNewGroup={setShowNewGroup} />
            <UpdateGroup 
                showUpdateGroup={showUpdateGroup} 
                setShowUpdateGroup={setShowUpdateGroup}
                groupe={selectedGroup}
            />

            {/* Modale de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir supprimer le groupe <strong>{groupeToDelete?.name}</strong> ?</p>
                    <p className="text-muted small">Cette action est irréversible.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={isDeleting}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={confirmDelete} disabled={isDeleting}>
                        {isDeleting ? 'Suppression...' : 'Supprimer'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GroupesTab;

